// extracted by mini-css-extract-plugin
export default {"container":"multiline-ellipsis_container__Tk56X","text":"multiline-ellipsis_text__hgPZ9"};